module.exports = __webpack_public_path__ + "static/NanumMyeongjo-Regular-d154243d4cbaf269057c46fa93eb27c6.woff2";